import React, {Component} from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  CardSubtitle,
  CardText,
  CardFooter,
} from "reactstrap";

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import {countries} from '../../../lib/countries'

// Import actions
import { myaccountRequest, myaccountPosting } from './actions'
import { FieldText } from '../../controls/_FieldValication';
import Messages from '../../../notifications/Messages'
import Errors from '../../../notifications/Errors'

import {
  MYACCOUNT_REQUESTING,
  MYACCOUNT_REQUEST_SUCCESS,
  MYACCOUNT_POST_SUCCESS,
} from './constants'

class MyAccount extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    profile: PropTypes.shape({
      type: PropTypes.string,
      data: PropTypes.object,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }).isRequired,
    myaccountRequest: PropTypes.func.isRequired, // <-- new
    myaccountPosting: PropTypes.func,
  }

  constructor(props) {
    super(props);

    this.state = {
      data: {}
    }
  }

  componentDidMount() {
    this.getInfo();
  }

  submit = (values) => {
    return this.props.myaccountPosting(values)
  }

  getInfo = () => {
    const { myaccountRequest } = this.props
    return myaccountRequest()
  }

  handleDateChange(date) {
    let { data } = this.state;
    data.NgaySinh = date;
    this.setState({data});
    this.props.initialize({"NgaySinh": data.NgaySinh.format('YYYY-MM-DD')});
  }

  handleCountryChange(event) {
    let { data } = this.state;
    data.RegionCode = event.target.value;
    this.setState({data});
    this.props.initialize({"RegionCode": data.RegionCode});
  }
  
  componentWillReceiveProps(nextProps){
    if (nextProps.profile.type == MYACCOUNT_REQUEST_SUCCESS){
      let { data } = this.state;
      data = nextProps.profile.data;
      data.NgaySinh = data.NgaySinh ? moment(data.NgaySinh).local().format('DD/MM/YYYY') :null,

      this.setState({data});
    }
  }

  render() {
    const {
      handleSubmit,
      profile: {
        requesting,
        messages,
        errors
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={requesting}>
          <Row className="justify-content-center">
            <Col md="12">
            <form method="post" onSubmit={handleSubmit(this.submit)}>
              <Card>
                <CardBody>
                  <Row>
                    <Col sm="6">
                      <Card>
                        <CardBody>
                          <CardSubtitle>Tài khoản</CardSubtitle>
                          <CardText>{this.state.data.username}</CardText>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col sm="6">
                      <Card>
                        <CardBody>
                          <CardSubtitle>Email</CardSubtitle>
                          <CardText>{this.state.data.email}</CardText>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <Card>
                        <CardBody>
                          <CardSubtitle>Họ tên</CardSubtitle>
                          <CardText>{this.state.data.TenDayDu}</CardText>
                            {/* <Field name="TenDayDu" initValue={this.state.data.TenDayDu} component={FieldText} type="text" placeholder="Tên đầy đủ" className={"form-control"} /> */}
                        </CardBody>
                      </Card>
                    </Col>
                    <Col sm="6">
                      <Card>
                        <CardBody>
                          <CardSubtitle>Điện thoại</CardSubtitle>
                          <CardText>{this.state.data.DienThoai}</CardText>
                            {/* <Field type="text" name="DienThoai" initValue={this.state.data.DienThoai} className={"form-control"} component={FieldText}/> */}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <Card>
                        <CardBody>
                          <CardSubtitle>Ngày sinh</CardSubtitle>
                          <CardText>{this.state.data.NgaySinh}</CardText>
                            {/* <Field type="hidden" name="NgaySinh" initValue={this.state.data.NgaySinh} component={FieldText}/> */}
                            {/* <DatePicker name="NgaySinh_c" placeholder="MM/dd/YYYY"
                             selected={this.state.data.NgaySinh}
                              onChange={this.handleDateChange.bind(this)} 
                              className={"form-control"}
                              disabled={true} /> */}
                        </CardBody>
                      </Card>
                    </Col>
                    {/* <Col sm="6">
                      <Card>
                        <CardBody>
                          <CardSubtitle>Country</CardSubtitle>
                            <br />
                            <Field type="hidden" name="RegionCode" value={this.state.data.RegionCode} component={FieldText}/>
                            <select name="RegionCode_c" value={this.state.data.RegionCode} onChange={this.handleCountryChange.bind(this)} className={"form-control"}>
                              <option value="">Select a region...</option>
                              {countries.map(option => {
                                return (
                                <option  value={option.code} key={option.code}>
                                  {option.name}
                                </option>
                                )})}
                            </select>
                        </CardBody>
                      </Card>
                    </Col> */}
                    <Col sm="6">
                      <Card>
                        <CardBody>
                          <CardSubtitle>Địa chỉ</CardSubtitle>
                          <CardText>{this.state.data.DiaChi}</CardText>
                            {/* <Field type="text" initValue={this.state.data.DiaChi} name="DiaChi" className={"form-control"} component={FieldText}/> */}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                  </Row>
                  <Row>
                    <Col md="12">
                    {!requesting && !!errors.length && (
                      <Errors message="Failure to signup due to:" errors={errors} />
                    )}
                    {!requesting && !!messages.length && (
                      <Messages messages={messages} />
                    )}  
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <Row>
                    <Col xs="12">
                      {/* <Button color="primary" className="btn btn-brand" action="submit">
                        <i className="fa fa-save"></i>
                        <span>{" "}Lưu</span>
                      </Button> */}
                      &nbsp;
                    </Col>
                  </Row>
                </CardFooter>
              </Card>
              </form>
            </Col>
          </Row>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  profile: state.profile,
  initialValues: state.profile.data,
})

const connected = connect(mapStateToProps, { myaccountRequest, myaccountPosting })(MyAccount)

const formed = reduxForm({
  form: 'profile',
  enableReinitialize: true,
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/Pages/MyAccount/MyAccount.js